// src/services/api.js

const API_BASE =
  process.env.REACT_APP_API_URL ||
  'https://agentsmarket-backend-1eddf19518ca.herokuapp.com';

// Genel fetch wrapper
async function request(path, { method = 'GET', body, headers = {} } = {}) {
  const url = `${API_BASE}${path}`;
  const opts = {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
  };
  if (body) opts.body = JSON.stringify(body);

  const res = await fetch(url, opts);
  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(`API ${res.status}: ${errorText}`);
  }
  return res.json();
}

// E-posta abonelikleri
export function fetchEmails() {
  return request('/api/emails');
}

export function subscribeEmail(email) {
  return request('/api/emails', {
    method: 'POST',
    body: { email },
  });
}

export default {
  fetchEmails,
  subscribeEmail,
};
